"use strict";

exports.__esModule = true;
exports.TYPE_OPTIONS = exports.TOKENS = exports.ELEMENT_OPTIONS = exports.ALIGN = void 0;
let ELEMENT_OPTIONS = exports.ELEMENT_OPTIONS = /*#__PURE__*/function (ELEMENT_OPTIONS) {
  ELEMENT_OPTIONS["H1"] = "h1";
  ELEMENT_OPTIONS["H2"] = "h2";
  ELEMENT_OPTIONS["H3"] = "h3";
  ELEMENT_OPTIONS["H4"] = "h4";
  ELEMENT_OPTIONS["H5"] = "h5";
  ELEMENT_OPTIONS["H6"] = "h6";
  ELEMENT_OPTIONS["DIV"] = "div";
  return ELEMENT_OPTIONS;
}({});
let TYPE_OPTIONS = exports.TYPE_OPTIONS = /*#__PURE__*/function (TYPE_OPTIONS) {
  TYPE_OPTIONS["DISPLAY"] = "display";
  TYPE_OPTIONS["DISPLAYSUBTITLE"] = "displaySubtitle";
  TYPE_OPTIONS["TITLE1"] = "title1";
  TYPE_OPTIONS["TITLE2"] = "title2";
  TYPE_OPTIONS["TITLE3"] = "title3";
  TYPE_OPTIONS["TITLE4"] = "title4";
  TYPE_OPTIONS["TITLE5"] = "title5";
  TYPE_OPTIONS["TITLE6"] = "title6";
  return TYPE_OPTIONS;
}({});
let TOKENS = exports.TOKENS = /*#__PURE__*/function (TOKENS) {
  TOKENS["weightHeading"] = "weightHeading";
  TOKENS["sizeHeading"] = "sizeHeading";
  TOKENS["lineHeight"] = "lineHeight";
  return TOKENS;
}({});
let ALIGN = exports.ALIGN = /*#__PURE__*/function (ALIGN) {
  ALIGN["START"] = "start";
  ALIGN["CENTER"] = "center";
  ALIGN["END"] = "end";
  ALIGN["JUSTIFY"] = "justify";
  return ALIGN;
}({});